import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { BatchMailItemType } from '@ukpostbox/client-data/lib/Types/ForwardingBatchTypes';
import { Button, ColourStateSolid } from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { SearchMailItemsForBatchModal } from '../Modals/SearchMailItemsForBatchModal';
import { BatchMailItemsComplete } from './BatchMailItemsComplete';
import { BatchMailItemEntries } from './BatchMailItemEntries';

function BatchMailItems(props: RenderBatchSectionType) {
	const { currentBatchData, AddMailItemToBatch, RemoveMailItemFromBatch } = useForwardingBatchProvider();

	const [mailItemSearchOpen, setMailItemSearchOpen] = useState<boolean>(false);
	const [selectedBatchMailUuids, setSelectedBatchMailUuids] = useState<Array<string>>(
		currentBatchData ? currentBatchData?.items.map((item) => item.mailUuid) : [],
	);

	useEffect(() => {
		if (currentBatchData) {
			setSelectedBatchMailUuids(currentBatchData?.items.map((item) => item.mailUuid));
		}
	}, [currentBatchData]);

	const HandleAddMailItems = (selectedMailItems: Array<BatchMailItemType>) => {
		const mailUuids: Array<string> = selectedMailItems.map((item) => item.mailUuid);

		setMailItemSearchOpen(false);

		setSelectedBatchMailUuids(selectedBatchMailUuids ? [...selectedBatchMailUuids, ...mailUuids] : mailUuids);

		if (currentBatchData?.batchId) {
			AddMailItemToBatch(mailUuids, selectedMailItems);
		}
	};

	const HandleRemoveMailItem = (mailUuid: string) => {
		const mailUuids: Array<string> = selectedBatchMailUuids ? [...selectedBatchMailUuids] : [];
		mailUuids.splice(mailUuids.indexOf(mailUuid), 1);

		setSelectedBatchMailUuids(mailUuids);

		if (currentBatchData?.batchId) {
			RemoveMailItemFromBatch(mailUuid);
		}
	};

	if (props.complete) return <BatchMailItemsComplete {...props} />;

	return (
		<div>
			<h5 className='mb-xs'>
				{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}
			</h5>
			<p>
				Please ensure you tell us about everything your letters/parcels contain. You can add additional rows
				using the "Add Contents" button
			</p>
			<p>
				If the value of any individual item in your batch is above £5000.00, please contact our Mail-room
				Forwarding team.
			</p>

			<div className='mb-md'>
				<BatchMailItemEntries {...props} removeMailItemCallback={HandleRemoveMailItem} />
			</div>

			<Button
				title='Add Mailboxes Item'
				icon={faPlus}
				colour={ColourStateSolid.Primary}
				fullWidth
				onClick={() => setMailItemSearchOpen(true)}
				disabled={props.readOnly}
			/>

			<SearchMailItemsForBatchModal
				isOpen={mailItemSearchOpen}
				batchMailUuids={selectedBatchMailUuids}
				closeCallback={() => setMailItemSearchOpen(false)}
				actionedCallback={(e: Array<BatchMailItemType>) => HandleAddMailItems(e)}
			/>
		</div>
	);
}

export { BatchMailItems };
